import { client } from '@stores'
import { DateUtil, formatDate2 } from '@utils'
import gql from 'graphql-tag'

interface UpdateBookingInputT {
  id: string
  startDate: DateUtil
  endDate: DateUtil
  note: string
}

export default {
  updateBooking: ({ id, note, startDate, endDate }: UpdateBookingInputT) => {
    const dateValues = {
      startDate: formatDate2(startDate),
      endDate: formatDate2(endDate),
    }
    return client.gql.mutate({
      mutation: updateBookingMutation,
      variables: { input: { id, note, ...dateValues } },
    })
  },
}
// export default {
//   getSpaceBookings(id) {
//     return gql.query(fetchSpaceBookings, { id })
//   },

//   booking({ id, startDate, endDate }) {
//     return gql.mutate(updateBooking, { input: { id, startDate, endDate } })
//   },

//   schedule(input) {
//     return gql.mutate(updateBookingSchedule, { input })
//   },
// }

const updateBookingMutation = gql`
  mutation updateBookingMutation($input: UpdateBookingInput!) {
    updateBooking(input: $input) {
      booking {
        id
        space {
          id
        }
        employee {
          id
        }
        startDate
        endDate
        checkedIn
        passedHealthCheck
      }
    }
  }
`
